import React, { useState } from "react";
import Sidebar from "../components/sidebar";
import Navbar from "../components/navbar";
import card from "../imgs/card.svg";
import copy from "../imgs/copy.svg";
import edit from "../imgs/edit.svg";
import share from "../imgs/share.svg";
import wallet from "../imgs/wallet.svg";

function Dashboard() {
  const [page, setPage] = useState("dashboard");
  return (
    <div className="flex">
      <Sidebar page={page} />
      <div className=" ml-[304px] w-full">
        <Navbar />
        <div className="flex px-8 gap-6">
          <div className="min-w-[463px] flex flex-col gap-5">
            <div className="border-2 flex justify-between items-center  border-[#D7E1F4] rounded-3xl p-6">
              <div className="flex flex-col gap-2">
                <p className="text-[#3C517C] text-[16px] leading-7 tracking-[2%]">
                  Wallet Balance
                </p>
                <p className="text-[#3C517C] font-semibold text-[36px] leading-7 tracking-[2%]">
                  ₦3000
                </p>
              </div>
              <button className="bg-[#4169E1] cursor-not-allowed hover:bg-[#000080] text-[white] rounded-lg h-[50px] px-[50px]">
                Fund Wallet
              </button>
            </div>
            <div className="border-2 flex flex-col gap-4 border-[#D7E1F4] rounded-3xl p-6">
              <div className="text-[#3C517C] text-[16px] leading-7 tracking-[2%] ">
                <p>Referral</p>
                <p className="mt-[4px]">
                  Referral Code:{" "}
                  <span className="font-semibold">18/52ha089</span>
                </p>
              </div>
              <div className="flex gap-4 text-[#4169E1] font-semibold text-[16px] leading-4 tracking-[2%]">
                <div className="flex gap-1 items-center">
                  <img src={copy} alt="" />{" "}
                  <p className="hover:text-[#000080] active:opacity-85">Copy</p>
                </div>
                <div className="flex gap-1 items-center">
                  <img src={edit} alt="" />{" "}
                  <p className="hover:text-[#000080] active:opacity-85">Edit</p>
                </div>
                <div className="flex gap-1 items-center">
                  <img src={share} alt="" />{" "}
                  <p className="hover:text-[#000080] active:opacity-85">
                    Share
                  </p>
                </div>
              </div>
            </div>
            <div className="border-2 flex justify-between   border-[#D7E1F4] rounded-3xl p-6">
              <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-2">
                  <p className="text-[#3C517C] text-[16px] leading-7 tracking-[2%]">
                    Total referrals made
                  </p>
                  <p className="text-[#3C517C] font-semibold text-[24px] leading-7 tracking-[2%]">
                    0
                  </p>
                </div>
                <div className="flex gap-1 items-center">
                  <img src={wallet} alt="" />{" "}
                  <p className=" text-[#4169E1] font-semibold text-[16px] leading-4 tracking-[2%] hover:text-[#000080] active:opacity-85">
                    Cashout
                  </p>
                </div>
              </div>
              <div className="flex flex-col gap-2">
                <p className="text-[#3C517C] text-[16px] leading-7 tracking-[2%]">
                  Current wallet Bonus
                </p>
                <p className="text-[#3C517C] font-semibold text-[24px] leading-7 tracking-[2%]">
                  ₦0.00
                </p>
              </div>
            </div>
          </div>
          <div className="">
            <img src={card} alt="" className="min-w-[504px]" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
